import React from 'react'
import { Rating } from 'react-simple-star-rating'

const RatingDisplay = ({ selectedValue, readonly = true }) => {
  return <Rating initialValue={selectedValue} size={25} fillColor={'#FD9B2E'} emptyColor={'gray'} allowFraction transition readonly={readonly} />
}
export default RatingDisplay
